/**
 * Vérifie si l'utilisateur est sur un appareil mobile
 * @returns {boolean}
 */
function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isSmallScreen = window.innerWidth < 991.98;
  const isMobileAgent = /android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent.toLowerCase());
  return isSmallScreen || isMobileAgent;
}

function isTouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

/**
* Limite la fréquence d'exécution d'une fonction à après un certain délai sans activité
* @param {Function} func - La fonction à exécuter
* @param {number} delay - Temps en millisecondes
* @returns {Function}
*/
function debounce(func, delay) {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
}

/**
* Limite la fréquence d'exécution d'une fonction à un intervalle fixe
* @param {Function} func - La fonction à exécuter
* @param {number} limit - Temps en millisecondes
* @returns {Function}
*/
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function (...args) {
    const context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

/**
* Vérifie si une valeur est un objet
* @param {*} value - La valeur à vérifier
* @returns {boolean}
*/
function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

/**
* Gère une attente asynchrone
* @param {number} ms - Temps d'attente en millisecondes
* @returns {Promise}
*/
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
* Récupère un paramètre dans l'URL
* @param {string} name - Nom du paramètre
* @returns {string|null}
*/
function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

/**
* Génère une chaîne de caractères aléatoire
* @param {number} length - Longueur de la chaîne
* @returns {string}
*/
function randomString(length = 8) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
* Convertit une chaîne de caractères en format "slug" (utilisé pour les URLs)
* @param {string} text - Le texte à convertir
* @returns {string}
*/
function toSlug(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, '-'); // Remplace les espaces et caractères spéciaux par des tirets
}

const isLogged = () => {
  const admin = localStorage.getItem('admin');
  return admin !== null;
};

// Récupère les infos de l'admin connecté
const getLoggedAdmin = () => {
  if (!isLogged()) {
    return null;
  }

  try {
    return JSON.parse(localStorage.getItem('admin'));
  } catch (error) {
    console.error("Erreur lors de la récupération de l'admin :", error);
    return null;
  }
};
module.exports = {
  isMobile,
  isTouch,
  debounce,
  throttle,
  isObject,
  sleep,
  getQueryParam,
  randomString,
  toSlug,
  isLogged,
  getLoggedAdmin,
};
